<script>
    export let timeString = "0:00";
</script>

<style>
div {
    font-size: 6rem;
    line-height: 1em;
    margin-left: 2rem;
    text-shadow: 1px 1px 6px black;
}
</style>

<div>
    {timeString}
</div>